import {ElementRef, inject, Injector} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {DotRendererService} from '@ng-dot/core';

/**
 * 대화상자 컴포넌트 기반
 */
export abstract class DialogBase<T = any> {
	maximize: boolean;
	protected _renderer: DotRendererService;
	protected elementRef: ElementRef;

	protected constructor(
		protected dialogRef: MatDialogRef<T>,

	) {
		const injector = inject(Injector);
		this._renderer = injector.get(DotRendererService);
		this.elementRef = injector.get(ElementRef);
	}

	resize(){
		const {_renderer, elementRef: {nativeElement}} = this;
		if(this.maximize){
			this.maximize = false;
			_renderer.removeClass(nativeElement, '_maximize');
			return false;
		}else{
			_renderer.addClass(nativeElement, '_maximize');
			this.maximize =true;
			return true;
		}
	}
	/**
	 * 대화상자 닫기
	 */
	close() {
		this.dialogRef.close();
	}
}
